
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'version': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path fill-rule="evenodd" clip-rule="evenodd" d="M2.11765 0H15.8824C17.0524 0 18 0.947647 18 2.11765V10.5882C18 11.7582 17.0524 12.7059 15.8824 12.7059H2.11765C0.947647 12.7059 0 11.7582 0 10.5882V2.11765C0 0.947647 0.947647 0 2.11765 0ZM3.17647 10.5882H5.29412V4.23529H2.11765V6.35294H3.17647V10.5882ZM9.52941 10.5882H7.41176V8.47059H9.52941V10.5882ZM11.6471 10.5882H13.7647V8.47059H11.6471V10.5882Z" fill="#93A0AE"/>'
  }
})
